export default "__VITE_ASSET__BgQ6YkL___"